// eslint-disable-next-line import/prefer-default-export
export const modalsStack = (state) =>
  state.globalNotificationsReducer.consecutiveModalsStack;
export const isNotificationModalOpen = (state) =>
  state.globalNotificationsReducer.isNotificationModalOpen;
